// removed by extract-text-webpack-plugin
module.exports = {"Tiles":"v5ma4IQgDPxgngxDc70mk"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Tiles/Tiles.scss
 ** module id = 393
 ** module chunks = 1
 **/